import React, { useState, useEffect } from 'react';
import '../App.css';

function LightConfig({ socket }) {
  const [heightOffset, setHeightOffset] = useState(0.0);
  const [distanceBack, setDistanceBack] = useState(0.0);

  useEffect(() => {
    if (!socket) return;

    const handleConfigUpdated = (data) => {
      setHeightOffset(data.height_offset);
      setDistanceBack(data.distance_back);
    };

    socket.on('light_config_updated', handleConfigUpdated);

    return () => {
      socket.off('light_config_updated', handleConfigUpdated);
    };
  }, [socket]);

  const updateConfig = () => {
    if (socket) {
      socket.emit('update_light_config', {
        height_offset: heightOffset,
        distance_back: distanceBack
      });
    }
  };

  return (
    <div className="card">
      <h2>💡 Light Configuration</h2>
      
      <div className="input-group">
        <label>
          Light Height Above Camera (meters)
          <div style={{ fontSize: '0.9em', opacity: 0.8, marginTop: '5px' }}>
            Positive = light is above camera, Negative = below
          </div>
        </label>
        <input
          type="number"
          step="0.01"
          value={heightOffset}
          onChange={(e) => setHeightOffset(parseFloat(e.target.value) || 0)}
          style={{ marginTop: '10px' }}
        />
        <div style={{ marginTop: '5px', fontSize: '0.9em', opacity: 0.7 }}>
          Current: {heightOffset.toFixed(3)}m
        </div>
      </div>

      <div className="input-group">
        <label>
          Light Distance Behind Camera (meters)
          <div style={{ fontSize: '0.9em', opacity: 0.8, marginTop: '5px' }}>
            Positive = light is behind camera, 0 = at camera position
          </div>
        </label>
        <input
          type="number"
          step="0.01"
          value={distanceBack}
          onChange={(e) => setDistanceBack(parseFloat(e.target.value) || 0)}
          style={{ marginTop: '10px' }}
        />
        <div style={{ marginTop: '5px', fontSize: '0.9em', opacity: 0.7 }}>
          Current: {distanceBack.toFixed(3)}m
        </div>
      </div>

      <button 
        className="button success" 
        onClick={updateConfig}
        style={{ width: '100%', marginTop: '15px' }}
      >
        Update Light Position
      </button>

      <div style={{ 
        marginTop: '20px', 
        padding: '15px', 
        background: 'rgba(0, 0, 0, 0.2)', 
        borderRadius: '10px' 
      }}>
        <h3 style={{ marginBottom: '10px' }}>Configuration Info</h3>
        <p style={{ fontSize: '0.9em', lineHeight: '1.6' }}>
          <strong>Default:</strong> Light is at camera position (both values = 0)<br />
          <strong>Height Offset:</strong> Adjust if light is above/below camera<br />
          <strong>Distance Back:</strong> Adjust if light is behind the camera
        </p>
      </div>
    </div>
  );
}

export default LightConfig;
